import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    ChatUser1Img,
    ChatUser2Img,
    ChatUser3Img,
    ChatUser4Img,
    SendIcon
} from "../../Constant/Index";
const TherapistChat = () => {
    const [showChat, SetShowChat] = useState(false);
    const chatUsers = [
        {
            name: "John Doe",
            currentMessage: "Lorem ipsum dolor sit amet,",
            time: "2 Hours Ago",
            image: ChatUser1Img,
            active: false,
            newchats: 0
        },
        {
            name: "Emily Clark",
            currentMessage: "Lorem ipsum dolor sit amet,",
            time: "5 Days Ago",
            image: ChatUser2Img,
            active: false,
            newchats: 0
        },
        {
            name: "John Doe",
            currentMessage: "Lorem ipsum dolor sit amet,",
            time: "7 Days Ago",
            image: ChatUser3Img,
            active: true,
            newchats: 2
        },
        {
            name: "Robert Williams",
            currentMessage: "Lorem ipsum dolor sit amet,",
            time: "1 Week Ago",
            image: ChatUser4Img,
            active: false,
            newchats: 0
        },
    ];
    const openChat = () => {
        SetShowChat(!showChat);
    }
    const closeChat = () => {
        // SetShowChat(false);
        SetShowChat(!showChat);
    }
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                    <h3 className="md-heading min-width-fit mb-0">Chats</h3>
                                    <hr className="w-100" />
                                </div>
                                <button className={`btn ${(showChat) ? '' : ''}  d-lg-none`} onClick={openChat}><i className="fa fa-angle-left fa-2x"></i></button>
                                <div className="profile-box p-0">
                                    <div className="chat-application overflow-hidden position-relative">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-12 pe-0">
                                                <div className={`messages-list-area ${(showChat) ? 'active' : ''}`}>
                                                    <div className="top-area">
                                                        <div className="top-text">
                                                            <h6 className="xs-heading">Messages</h6>
                                                            <span className="alert-here">3+ New</span>
                                                        </div>
                                                        <div className="searc-comversation">
                                                            <input type="text" name="" id="" placeholder="Search Here" className="search" />
                                                            <button className="search-btn">
                                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M15.7992 4.6L16.9992 5.8M12.1992 3C12.1992 3.53043 12.4099 4.03914 12.785 4.41421C13.1601 4.78929 13.6688 5 14.1992 5C14.7297 5 15.2384 4.78929 15.6134 4.41421C15.9885 4.03914 16.1992 3.53043 16.1992 3C16.1992 2.46957 15.9885 1.96086 15.6134 1.58579C15.2384 1.21071 14.7297 1 14.1992 1C13.6688 1 13.1601 1.21071 12.785 1.58579C12.4099 1.96086 12.1992 2.46957 12.1992 3Z" stroke="#4D6E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M9.8 1.04C9.5368 1.0136 9.2704 1 9 1C4.5816 1 1 4.5816 1 9C1 10.4568 1.3896 11.824 2.0704 13L1.4 16.6L5 15.9296C6.21563 16.6328 7.59561 17.0021 9 17C13.4184 17 17 13.4184 17 9C17 8.7296 16.9864 8.4632 16.96 8.2" stroke="#4D6E72" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <h6 className="recent">Recent</h6>
                                                    </div>
                                                    <div className="friends-list">
                                                        {
                                                            chatUsers.map((singleUser, index) => (
                                                                <button className={`single-friends border-0 ${(singleUser.active) ? 'active' : ''}`} key={index} onClick={closeChat}>
                                                                    <figure>
                                                                        <img src={singleUser.image} alt={singleUser.name} />
                                                                    </figure>
                                                                    <div className="about-user">
                                                                        <div className="username-date">
                                                                            <span className="username">{singleUser.name}</span>
                                                                            <span className="date">{singleUser.time}
                                                                                {(singleUser.newchats > 0) ? <span className="nex-chats">{singleUser.newchats}</span> : ''}
                                                                            </span>
                                                                        </div>
                                                                        <p>{singleUser.currentMessage}</p>
                                                                    </div>
                                                                </button>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-12 ps-0">
                                                <div className="chat-start">
                                                    <div className="chat-header">
                                                        <figure className="user-pic active">
                                                            <img src={ChatUser2Img} alt="" />
                                                            <span className="active-user"></span>
                                                        </figure>
                                                        <div className="about-user">
                                                            <span className="user-name">Emily Clark</span>
                                                            <span className="user-role">Child Spacilists</span>
                                                        </div>
                                                    </div>
                                                    <div className="chat-body">
                                                        <div className="day-chenge">
                                                            <span className="showday">5 Days Ago</span>
                                                        </div>
                                                        <div className="single-message recieved-message">
                                                            <div className="message">
                                                                <p>Lorem ipsum dolor sit amet, consec tetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                                                <span>22:01</span>
                                                            </div>
                                                        </div>
                                                        <div className="single-message send-message">
                                                            <div className="message">
                                                                <p>Lorem ipsum dolor sit amet</p>
                                                                <span>22:01</span>
                                                            </div>
                                                        </div>

                                                        <div className="single-message recieved-message">
                                                            <div className="message">
                                                                <p>Lorem ipsum dolor sit amet</p>
                                                                <span>22:01</span>
                                                            </div>
                                                        </div>
                                                        <div className="single-message send-message">
                                                            <div className="message">
                                                                <p>Lorem ipsum dolor sit amet</p>
                                                                <span>22:01</span>
                                                            </div>
                                                        </div>

                                                        <div className="single-message recieved-message">
                                                            <div className="message">
                                                                <p>Lorem ipsum dolor sit amet</p>
                                                                <span>22:01</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="chat-footer">
                                                        <div className="check-send-box">
                                                            <input type="text" name="" className="form-control" id="" placeholder="Type Your Message" />
                                                            <button className="icon-bar">
                                                                <svg width="17" height="17" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9.625 18.25C14.3885 18.25 18.25 14.3885 18.25 9.625C18.25 4.86154 14.3885 1 9.625 1C4.86154 1 1 4.86154 1 9.625C1 14.3885 4.86154 18.25 9.625 18.25Z" stroke="#01323B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M6.74609 7.70801H6.75609" stroke="#01323B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12.4961 7.70801H12.5061" stroke="#01323B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M7.23047 12.5C7.86135 13.1439 8.72485 13.5067 9.6263 13.5067C10.5277 13.5067 11.3913 13.1439 12.0221 12.5" stroke="#01323B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <button className="send-btn"><img src={SendIcon} alt="" /></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default TherapistChat;